
export const projects = [
  {
    id: 1,
    title: 'Entertainment & Dining Venue',
    category: 'Commercial Architecture',
    image: 'https://media-manager-c.questera.ai/greta-media/ed00222917f6c77a55ea8d2212b2179b0f515c1262a399d5885ad9a7986bc697479c974a1fb3a0fd5daf63013277d6b3/images/aW1hZ2UvcG5n/f11732d8a2f779899f2466a565b0149c.png',
    span: 'col-span-1 md:col-span-2 row-span-1'
  },
  {
    id: 2,
    title: 'Car Collection Club',
    category: 'Commercial Architecture',
    image: 'https://media-manager-c.questera.ai/greta-media/ed00222917f6c77a55ea8d2212b2179b0f515c1262a399d5885ad9a7986bc697479c974a1fb3a0fd5daf63013277d6b3/images/aW1hZ2UvcG5n/f1bfb039a0e916404d7622d91361cd95.png',
    span: 'col-span-1 row-span-1'
  },
  {
    id: 3,
    title: 'Aura Penthouse',
    category: 'Interior Visualization',
    image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?q=80&w=2067&auto=format&fit=crop',
    span: 'col-span-1 row-span-1'
  },
  {
    id: 4,
    title: 'Zenith Pavilion',
    category: 'Landscape Integration',
    image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=2070&auto=format&fit=crop',
    span: 'col-span-1 md:col-span-2 row-span-1'
  },
  {
    id: 5,
    title: 'Nova Workspace',
    category: 'Interior Visualization',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2069&auto=format&fit=crop',
    span: 'col-span-1 row-span-2'
  },
  {
    id: 6,
    title: 'Gourmet Restaurant',
    category: 'Interior Visualization',
    image: 'https://media-manager-c.questera.ai/greta-media/ed00222917f6c77a55ea8d2212b2179b0f515c1262a399d5885ad9a7986bc697479c974a1fb3a0fd5daf63013277d6b3/images/aW1hZ2UvcG5n/e833169e7b20c887baa14b3118de61a2.png',
    span: 'col-span-1 row-span-1'
  },
  {
    id: 7,
    title: 'Retail Shopping Center',
    category: 'Commercial Architecture',
    image: 'https://media-manager-c.questera.ai/greta-media/ed00222917f6c77a55ea8d2212b2179b0f515c1262a399d5885ad9a7986bc697479c974a1fb3a0fd5daf63013277d6b3/images/aW1hZ2UvcG5n/8e44984d3c0d87cdee960cb7925247c5.png',
    span: 'col-span-1 row-span-1'
  },
  {
    id: 8,
    title: 'Gourmet Restaurant',
    category: 'Commercial Architecture',
    image: 'https://media-manager-c.questera.ai/greta-media/ed00222917f6c77a55ea8d2212b2179b0f515c1262a399d5885ad9a7986bc697479c974a1fb3a0fd5daf63013277d6b3/images/aW1hZ2UvcG5n/a9a6f662d17ea0703fc6bf759043050e.png',
    span: 'col-span-1 row-span-1'
  },
  {
    id: 9,
    title: 'Medical Office Building',
    category: 'Commercial Architecture',
    image: 'https://media-manager-c.questera.ai/greta-media/ed00222917f6c77a55ea8d2212b2179b0f515c1262a399d5885ad9a7986bc697479c974a1fb3a0fd5daf63013277d6b3/images/aW1hZ2UvanBlZw==/0743b9c49bdd1347ff2ac2cd5f6605e1.jpg',
    span: 'col-span-1 row-span-1'
  },
  {
    id: 10,
    title: 'Residential Exterior Patio Remodel',
    category: 'Exterior Visualization',
    image: 'https://media-manager-c.questera.ai/greta-media/ed00222917f6c77a55ea8d2212b2179b0f515c1262a399d5885ad9a7986bc697479c974a1fb3a0fd5daf63013277d6b3/images/aW1hZ2UvcG5n/68cadd7318ed7ca76777be82c5c15426.png',
    span: 'col-span-1 row-span-1'
  },
  {
    id: 11,
    title: 'Residential Exterior Patio Remodel',
    category: 'Exterior Visualization',
    image: 'https://media-manager-c.questera.ai/greta-media/ed00222917f6c77a55ea8d2212b2179b0f515c1262a399d5885ad9a7986bc697479c974a1fb3a0fd5daf63013277d6b3/images/aW1hZ2UvcG5n/f5875a63fa1772f7e7f76c2b3dca0bc6.png',
    span: 'col-span-1 row-span-1'
  }
];

export const services = [
  {
    title: 'Exterior Rendering',
    description: 'Photorealistic visualisations of architectural exteriors, capturing mood, lighting, and environmental context.',
    icon: 'FiHome'
  },
  {
    title: 'Interior Visualization',
    description: 'Highly detailed interior renders showcasing materials, lighting, and spatial atmosphere for real estate and design.',
    icon: 'FiLayout'
  },
  {
    title: '3D Floor Plans',
    description: 'Clear, engaging 3D top-down views that help clients understand spatial flow and layout dimensions.',
    icon: 'FiMap'
  },
  {
    title: 'Architectural Animation',
    description: 'Cinematic walkthroughs and flyovers that bring unbuilt spaces to life with fluid motion and realistic lighting.',
    icon: 'FiVideo'
  }
];
